import { Attributes, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';

@NeoModel
export default class GLAccountType extends TemporalEntity {
    static typeName = "GLAccountType";

    public glAccountTypeId: number = 0;

    @Rules.StringLength(1)
    @Attributes.Display("GL Account Type Code")
    public glAccountTypeCode: string = "";

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("GL Account Type Name")
    public glAccountTypeName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.glAccountTypeCode) {
            return "New gl account type";
        } else {
            return this.glAccountTypeCode;
        }
    }
}